'use client';

import type { NextPage } from 'next'
import styles from '../../styles/event/Event.module.scss'
import { isEventAttended } from 'helpers/event'
import { Activity } from 'types/user'
import { attendEvent } from 'actions/activity'
import { newEventNotif, removeEventNotif } from 'helpers/notif'
import { useAppDispatch } from 'reducers/storeHooks'
import Button from 'componentsUnits/button';
import { Type } from 'types/type';
import { Size } from 'types/size';
import { updateToken } from 'actions/user';

interface Props {
  activity: Activity
  eventId: string
  eventTitle: string
  eventDescription: string
  startDate: Date
  startTime: string
}

const AttendComponent: NextPage<Props> = (props: Props) => {
  const dispatch = useAppDispatch()

  const isAttended = props.activity && isEventAttended(props.eventId, props.activity)
  const attendEventClicked = async (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const w = isAttended ? "Leave" : "Attend"
    if (!confirm(w + " the event '" + props.eventTitle + "' ?"))
      return

    !isAttended && newEventNotif(props.eventTitle, props.startDate, props.startTime)
    isAttended && removeEventNotif(props.startDate, props.startTime)
    await dispatch(updateToken());
    dispatch(attendEvent(props.eventId, !isAttended))
  }

  return (
    <Button
      size={Size.xxSmall}
      onClick={attendEventClicked}
      text={isAttended ? 'Leave' : 'Attend'}
      type={isAttended ? "7" : "1"}
    />
  )
}

export default AttendComponent
